import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchRecordTypesByApplication,
  fetchRecordTypesById,
  fetchRecordTypes,
  fetchTables,
  fetchTableFields,
} from "./recordTypes-async-calls";
import { RecordType, RecordTypessSlice } from "./recordTypes-interface";

const initialState: RecordTypessSlice = {
  recordTypes: [],
  selectedRecordType: null,
  selectedDataSource: null,
  selectedFields: [],
  selectedTables: [],
  selectedTableFields: [],
  isFetching: false,
};

const recordTypesSlice = createSlice({
  name: "recordTypes",
  initialState,
  reducers: {
    setSelectedRecordType: (state, action: PayloadAction<RecordType>) => {
      state.selectedRecordType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecordTypesByApplication.pending, (state) => {
        state.recordTypes = [];
        state.isFetching = true;
      })
      .addCase(fetchRecordTypesByApplication.fulfilled, (state, action) => {
        state.recordTypes = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchRecordTypesByApplication.rejected, (state) => {
        state.recordTypes = [];
        state.isFetching = false;
      })
      .addCase(fetchRecordTypes.pending, (state) => {
        state.recordTypes = [];
        state.isFetching = true;
      })
      .addCase(fetchRecordTypes.fulfilled, (state, action) => {
        state.recordTypes = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchRecordTypes.rejected, (state) => {
        state.recordTypes = [];
        state.isFetching = false;
      })
      .addCase(fetchRecordTypesById.pending, (state) => {
        state.selectedRecordType = null;
        state.selectedDataSource = null;
        state.selectedFields = [];
        state.isFetching = true;
      })
      .addCase(fetchRecordTypesById.fulfilled, (state, action) => {
        state.selectedRecordType = action.payload.recordType;
        state.selectedDataSource = action.payload.sourceMap[0];
        state.selectedFields = action.payload.fields;
        state.isFetching = false;
      })
      .addCase(fetchRecordTypesById.rejected, (state) => {
        state.selectedRecordType = null;
        state.selectedDataSource = null;
        state.selectedFields = [];
        state.isFetching = false;
      })
      .addCase(fetchTables.pending, (state) => {
        state.selectedTables = [];
      })
      .addCase(fetchTables.fulfilled, (state, action) => {
        state.selectedTables = action.payload;
      })
      .addCase(fetchTables.rejected, (state) => {
        state.selectedTables = [];
      })
      .addCase(fetchTableFields.pending, (state) => {
        state.selectedTableFields = [];
      })
      .addCase(fetchTableFields.fulfilled, (state, action) => {
        state.selectedTableFields = action.payload;
      })
      .addCase(fetchTableFields.rejected, (state) => {
        state.selectedTableFields = [];
      });
  },
});

export const { setSelectedRecordType } = recordTypesSlice.actions;

export default recordTypesSlice.reducer;
